module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James C. Clark\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("James C. Clark is a senior lecturer at the University of Central Florida. He is the author of ten books on Florida history, including "), _c('I', [_vm._v("Florida: A Concise History")]), _vm._v(", and the editor of a three-volume anthology of Florida literature. He earned his doctorate in Florida history at the University of Florida. His work has been honored by the Florida Historical Society, the Florida Magazine Association and the Florida Society of Newspaper Editors. He lives in Orlando.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/18kR0r7/tc-custom/9781439674871.jpg?1704586019402",
      "alt": "This image is the cover for the book Florida Literary Luminaries"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Florida Literary Luminaries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Sit down for a spell with the bevy of famed writers who've found inspiration in the Florida sun.")])]), _c('p', [_vm._v(" From the Spanish explorer Cabeza de Vaca to James Patterson, writers have found inspiration in the Florida sunshine. Ernest Hemingway met his future wife at Sloppy Joe's in Key West. John Kennedy recovered from back surgery in Palm Beach while working on his Pulitzer Prize winning book. James Weldon Johnson wrote what became The Negro National Anthem at the Stanton School in Jacksonville. And Edna St. Vincent Millay watched in shock as her manuscript went up in flames in Sanibel. Florida historian James Clark tells the stories of scores of writers including Robert Frost, Jack Kerouac, John D. MacDonald, and Stephen King. Hunter Thompson driving through the streets of Key West using a bullhorn to warn the citizens, Tennessee Williams partying with Truman Capote, Ring Lardner planning a get together with Al Capone--it's all here.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0